"use client";

import {tableService} from "@/service/table.service";
import {Progress} from "@nextui-org/react";
import {useEffect, useState} from "react";
type NeoSideBarCardProps = {
  sideBar: sideBar;
  request: any;
  setSidebarReqData: any;
};
type sideBar = {
  type: string;
  api_url: string;
  menu?: string;
};
export const RfidLog: React.FC<NeoSideBarCardProps> = ({
  sideBar: sidebar,
  request: request,
  setSidebarReqData: setSidebarReqData
}) => {
  const [sideBarData, setSidebarData] = useState<any>([]);
  useEffect(() => {
    const fetchData = async () => {
      const results = await tableService.onGet(sidebar.api_url, 4, request);
      // const response = await fetch(sideBar.api_url);
      // const data = await response.json();
      if (results.rows) {
        setSidebarData(results.rows);
      }
    };
    if (sidebar && sidebar.api_url && request) {
      fetchData();
    }
  }, [sidebar, request]);

  const changeVehicle = (trackerid: string) => {
    request.trackerId = trackerid;
    setSidebarReqData(request);
  };

  return (
    <>
      {sideBarData && sideBarData.length == 0 ? (
        <div className="w-full max-w-md rounded-lg border bg-white p-2 shadow-md">
          <h3 className="text-lg font-semibold text-gray-700">No Data Found</h3>
        </div>
      ) : (
        sideBarData.map((data: any, index: number) => {
          return (
            <div
              className="w-full max-w-md rounded-lg border bg-white p-4 shadow-md"
              key={index}
            >
              <h3 className="border-b-2  pb-2 text-lg font-semibold text-gray-700">
                {data.vehicleName}
              </h3>

              <div className="mt-2 flex items-center justify-between">
                <div className=" text-center">
                  <p className="text-sm font-medium text-yellow-500">Total</p>
                  <p className="text-xl font-bold text-gray-700">
                    {data.totalSwipe}
                  </p>
                </div>

                <div className=" text-center">
                  <p className="text-sm font-medium text-green-500">Assigned</p>
                  <div className="flex items-center gap-4">
                    <Progress
                      aria-label="Loading..."
                      size="sm"
                      value={data.assignedswipedCount}
                      color="success"
                      className="flex-1"
                    />
                    <span className="text-xs text-default-500">
                      {data.assignedswipedCount}%
                    </span>
                  </div>
                  <p className="text-xl font-bold">
                    {data.assignedswipedCount}
                  </p>
                </div>

                <div className=" text-center">
                  <p className="text-sm font-medium text-red-500">Unassigned</p>
                  <div className="flex items-center gap-4">
                    <Progress
                      aria-label="Loading..."
                      size="sm"
                      value={data.unAssignedswipedCount}
                      color="success"
                      className="flex-1"
                    />
                    <span className="text-xs text-default-500">
                      {data.unAssignedswipedCount}%
                    </span>
                  </div>
                  <p className="text-xl font-bold">
                    {data.unAssignedswipedCount}
                  </p>
                </div>
              </div>

              <button
                className="mt-2 w-full rounded-lg border bg-neo-white py-1 text-sm font-medium text-neo-black transition hover:bg-green-700"
                onClick={() => changeVehicle(data.trackerid)}
              >
                View Details →
              </button>
            </div>
          );
        })
      )}
    </>
  );
};
